<template>
  <figure class="order-image">
    <div class="circle">
      <CloudLeft class="cloud-left" />
      <CloudRight class="cloud-right" />
      <component :is="activeIllustration" />
    </div>
  </figure>
</template>

<script>
import { OrderZero, OrderOne, OrderTwo, OrderThree, OrderFour, OrderFive, OrderBus, OrderBusPlus, OrderBoat, CloudLeft, CloudRight } from './icons'
export default {
  name: 'OrderImage',
  props: {
    amount: {
      type: Number,
      default: 3
    }
  },
  computed: {
    activeIllustration () {
      if (this.amount > 15) {
        return OrderBoat
      }
      if (this.amount > 10) {
        return OrderBusPlus
      }
      if (this.amount > 5) {
        return OrderBus
      }
      if (this.amount > 4) {
        return OrderFive
      }
      if (this.amount > 3) {
        return OrderFour
      }
      if (this.amount > 2) {
        return OrderThree
      }
      if (this.amount > 1) {
        return OrderTwo
      }
      if (this.amount > 0) {
        return OrderOne
      }
      return OrderZero
    }
  },
  components: {
    CloudLeft,
    CloudRight
  }
}
</script>

<style lang="scss" scoped>
.order-image {
  display: block;
  margin: 0;
  text-align: center;
}

.circle {
  width: 195px;
  height: 195px;
  border-radius: 50%;
  background-color: #EBEBE6;
  position: relative;
  margin: 0 auto;
}

@keyframes clouds {
  from,
  to {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }
}

.cloud-left,
.cloud-right {
  position: absolute;
  fill: white;
  z-index: 1;
}

.cloud-left {
  left: -41px;
  top: 22px;
  animation: clouds 2s linear infinite;
}

.cloud-right {
  top: 20px;
  left: 132px;
  animation: clouds 3s linear infinite;
}
</style>
